import AddonItem from './AddonItem';

export default AddonItem;
